import { render, staticRenderFns } from "./MyPcontent.vue?vue&type=template&id=28735a10&"
import script from "./MyPcontent.vue?vue&type=script&lang=js&"
export * from "./MyPcontent.vue?vue&type=script&lang=js&"
import style0 from "./MyPcontent.vue?vue&type=style&index=0&id=28735a10&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports